import mapActions from './mapActions';

export default mapActions('employees_masters_project_managers', {
    fetchAll_url: () => '/api/employees_masters_project_managers'
});